"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');






























const SEARCH_DELAY_MS = 300
const DEFAULT_PAGE_SIZE = 50

/* A server-paged table's search, filters, sort and page, and the page the
 * server returned for them. A new search, filter, sort or fetch goes back to
 * page 1; a reload keeps the page, unless it no longer exists, when it moves
 * to the last page there is. Only the latest request's answer shows. */
 const useDataTable = ({
  fetch, initialSort, initialFilters, pageSize = DEFAULT_PAGE_SIZE,
}) => {
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [query, setQuery] = _react.useState.call(void 0, '')
  const [filters, setFilters] = _react.useState(initialFilters)
  const [sort, setSort] = _react.useState(initialSort)
  const [paged, setPaged] = _react.useState({ scope: null, page: 0 })
  const [data, setData] = _react.useState(null)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, true)
  const [hasError, setHasError] = _react.useState.call(void 0, false)
  const [reloads, setReloads] = _react.useState.call(void 0, 0)

  _react.useEffect.call(void 0, () => {
    const timer = setTimeout(() => setQuery(search.trim()), SEARCH_DELAY_MS)
    return () => clearTimeout(timer)
  }, [search])

  // The page belongs to the scope it was chosen in: a new scope reads as
  // page 1 in the same render, so the old page is never requested for it.
  const scope = _react.useMemo.call(void 0, () => ({ fetch, query, filters, sort }), [fetch, query, filters, sort])
  const currentPage = paged.scope === scope ? paged.page : 0
  const setPage = _react.useCallback.call(void 0, (next) => setPaged({ scope, page: next }), [scope])

  const latest = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    const request = ++latest.current
    setIsLoading(true)
    setHasError(false)
    scope.fetch({
      query: scope.query,
      filters: scope.filters,
      sort: scope.sort.sort,
      desc: scope.sort.desc,
      offset: currentPage * pageSize,
      limit: pageSize,
    })
      .then(response => {
        if (request !== latest.current) return
        setData(response)
        setIsLoading(false)
        const lastPage = Math.max(0, Math.ceil(response.total / pageSize) - 1)
        if (currentPage > lastPage) setPaged({ scope, page: lastPage })
      })
      .catch(() => {
        if (request !== latest.current) return
        setHasError(true)
        setIsLoading(false)
      })
  }, [scope, currentPage, pageSize, reloads])

  // A new column sorts ascending first; the current one flips.
  const onSort = _react.useCallback.call(void 0, (column) => setSort(current => current.sort === column
    ? { sort: column, desc: !current.desc }
    : { sort: column, desc: false }), [])

  const reload = _react.useCallback.call(void 0, () => setReloads(n => n + 1), [])

  return {
    search,
    setSearch,
    query,
    filters,
    setFilters,
    sort,
    onSort,
    page: currentPage,
    setPage,
    pageSize,
    rows: _nullishCoalesce(_optionalChain([data, 'optionalAccess', _ => _.rows]), () => ( [])),
    total: _nullishCoalesce(_optionalChain([data, 'optionalAccess', _2 => _2.total]), () => ( 0)),
    hasLoaded: data !== null,
    isLoading,
    hasError,
    reload,
  }
}; exports.useDataTable = useDataTable


